import React, { Component } from 'react';
import './Card.css'

function Card(props) {

	const { copyright, date, explanation, hdurl, title, url } = props.data;

	return (
		<div className="card-main container-fluid">
			
			{ props.children }

      <div className='row'>
  			<div className='col'>
  				<h6 className='date special-text'>{ date }</h6>
  				<h2 className='title special-text'>{ title }</h2>
  				<p>{ explanation }</p>
  			</div>
      </div>
    </div>
	)
}

export default Card;